<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <o-icon
          clickable
          native-type="button"
          icon="times"
          @click.native="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <o-field label="Name">
          <o-input
            type="text"
            v-model="name"
            placeholder="Name"
            required>
          </o-input>
        </o-field>
      </section>
      <footer class="modal-card-foot">
        <o-button type="button" @click="$emit('close')">Close</o-button>
        <o-button variant="primary" @click="saveDepartment()">Save</o-button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: "DepartmentModal",
  props: ['title', 'initialData'],
  data() {
    return {
      name: this.initialData ? this.initialData.name : null,
    }
  },
  methods: {
    saveDepartment() {
      if (this.name) {
          this.$emit('onComplete', this.name)
          this.$emit('close')
        }
      else {
        this.$oruga.notification.open({
            message: 'Empty name',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
